import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import './styles.scss'
import ComponentLoader from '../component-loader'
import { getComponentLabel } from '../../helper'
import { Hidden, Visible } from '../../../Grid'
import { environment } from '../../../../../environment'

class SectionBox2ColumnAlternative extends PureComponent {
  render () {
    const sectionId = this.props.blueprint.id
    const section = this.props.factsheetBlueprint.factTree.sections[sectionId]
    const label = getComponentLabel(
      this.props.blueprint,
      section)
    return (
      <div className={'section-box-2-column-alternative'}>
        {label &&
        <div>
          <h3 className={'section-title'}>{label}</h3>
        </div>
        }
        <div className={'section-box-2-column-content-alternative'}>
          <Hidden xs sm>
            <div>
              {this.props.blueprint.components.filter((_, i) => i % 2 !== 1).map((component, index) => {
                const keyUsed = component && component.id ? component.id : `${this.props.blueprint.id}:col0:${index}`
                if (environment.IS_DEV && window.__LOG_FS_KEYS) {
                  if (!component || !component.id) {
                    console.warn('Factsheet key fallback used in SectionBox2ColumnAlternative (left column)', {
                      parentId: this.props.blueprint.id,
                      index,
                      component
                    })
                  }
                  console.debug('Factsheet key used (SectionBox2ColumnAlternative left):', keyUsed)
                }
                return <ComponentLoader key={keyUsed} blueprint={component}
                                        parentBlueprint={this.props.blueprint}
                                        factsheetBlueprint={this.props.factsheetBlueprint}/>
              })}
            </div>
            <div>
              <div>
                {this.props.blueprint.components.filter((_, i) => i % 2 === 1).map((component, index) => {
                  const keyUsed = component && component.id ? component.id : `${this.props.blueprint.id}:col1:${index}`
                  if (environment.IS_DEV && window.__LOG_FS_KEYS) {
                    if (!component || !component.id) {
                      console.warn('Factsheet key fallback used in SectionBox2ColumnAlternative (right column)', {
                        parentId: this.props.blueprint.id,
                        index,
                        component
                      })
                    }
                    console.debug('Factsheet key used (SectionBox2ColumnAlternative right):', keyUsed)
                  }
                  return <ComponentLoader key={keyUsed} blueprint={component}
                                          parentBlueprint={this.props.blueprint}
                                          factsheetBlueprint={this.props.factsheetBlueprint}/>
                })}
              </div>
            </div>
          </Hidden>
          <Visible xs sm>
            {this.props.blueprint.components.map((component, index) => {
              const keyUsed = component && component.id ? component.id : `${this.props.blueprint.id}:mobile:i${index}`
              if (environment.IS_DEV && window.__LOG_FS_KEYS) {
                if (!component || !component.id) {
                  console.warn('Factsheet key fallback used in SectionBox2ColumnAlternative (mobile list)', {
                    parentId: this.props.blueprint.id,
                    index,
                    component
                  })
                }
                console.debug('Factsheet key used (SectionBox2ColumnAlternative mobile):', keyUsed)
              }
              return <ComponentLoader key={keyUsed} blueprint={component}
                                      parentBlueprint={this.props.blueprint}
                                      factsheetBlueprint={this.props.factsheetBlueprint}/>
            })}
          </Visible>
        </div>
      </div>
    )
  }
}

SectionBox2ColumnAlternative.propTypes = {
  blueprint: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired
}
export default SectionBox2ColumnAlternative
